module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block4"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berkeley")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p153"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("T")]), _vm._v("he last two weeks of my college career fly by in a whirlwind of final exams, tearful exchanges with friends, and extra-special pressure from my parents to “get serious” with Grisham.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p154"
    }
  }, [_vm._v("That would be Grisham Abbot, the man, according to my parents, I’m going to marry.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p155"
    }
  }, [_vm._v("Grisham, quite honestly, is a great guy. He’s the son of a navy admiral, a man who serves just under my father at the base he commands. Grisham’s father and mine go way back to their days at the Naval Academy, where they both emerged as officers. Both men met their wives shortly thereafter, and the four of them have been an unstoppable team ever since. It’s only natural, at least in their minds, that Grisham and I live happily ever after as a product of their lifelong friendship.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p156"
    }
  }, [_vm._v("But Grisham’s just not "), _c('i', [_vm._v("my")]), _vm._v(" guy. He just graduated from the Naval Academy, exactly like our fathers. I don’t want to marry a younger version of my dad. I don’t want to become the new and improved carbon copy of my mom. That’s so not the life I’ve planned for myself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p157"
    }
  }, [_vm._v("What kind of life do I have planned for myself?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p158"
    }
  }, [_vm._v("Ain’t that the question of the century?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p159"
    }
  }, [_vm._v("I have no clue. Trained chimps have a better grasp on their future than I do. I graduated with a major in interior design. My mother thinks that’s perfect, because I’m going to be planning and designing navy events for the rest of my life. Sigh.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p160"
    }
  }, [_vm._v("My welcome home begins with a bang.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p161"
    }
  }, [_vm._v("My parents have thrown me a graduation extravaganza. Because my mother can’t just call it a party. That would be ludicrous.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p162"
    }
  }, [_vm._v("It’s also, in a sense, my “coming out” party with Grisham. My reflection in the full-length mirror in my bedroom at my parents’ house mocks me. The girl staring back at me looks as though she was made for this life. She was made to belong to affluent parents, her father one of the most powerful men in the United States military. Her mother is a flawless version of herself, always on top of her game, always the picture of class and authority. The girl staring back at me looks like she belongs on the arm of a handsome, clean-cut man of privilege who will work his way quickly through the ranks of the navy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p163"
    }
  }, [_vm._v("But inside that girl, another is fighting to claw her way to the surface. The real me, just waiting for a chance to spread her wings. The me who loves to run around in funny T-shirts and cutoffs. The me who spends hours in her room drawing beautiful spaces and painting canvases to hang on the walls inside of them. The me who is most at home in a seafood restaurant with old wooden floors and down-to-earth people who love me for me. Not for the future me who will make them proud, just the me I already am.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p164"
    }
  }, [_vm._v("I leave the room, shutting the door a little too loudly behind me, and crash directly into my mother.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p165"
    }
  }, [_vm._v("“Honey,” she coos. “You look beautiful. Here, let me fix your hair. This piece is falling down again. I wish you’d grow out these layers. And flatiron it. It really would become you so much better.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p166"
    }
  }, [_vm._v("I puff my lips out and blow, allowing the strand of hair in question to flutter flippantly around my face. “Better?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p167"
    }
  }, [_vm._v("She frowns, an expression her face doesn’t handle very well due to the monthly Botox injections.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p168"
    }
  }, [_vm._v("“Don’t be smart. Get downstairs. Grisham’s been waiting on you for thirty minutes, at least.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p169"
    }
  }, [_vm._v("“Grish knows me well enough to know he could be waiting all night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p170"
    }
  }, [_vm._v("My mother’s eyes roll skyward and I can almost hear her counting to ten.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p171"
    }
  }, [_vm._v("I hold up my hands in surrender. “All right, Momma. I’m going.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p172"
    }
  }, [_vm._v("The pins holding my hair up are already giving me a headache as I reach the bottom of our grand dual staircase, but I plaster a giant, fake smile on my face and begin to greet guests as they hover near me. Just dying to offer me their sincere congratulations on my completion of four years in college.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p173"
    }
  }, [_vm._v("The University of North Carolina at Wilmington wasn’t at all where my parents envisioned me earning my four-year degree. Since I was born a daughter and not a son, a military academy was out of the question. At least for my father. But they just knew I’d be headed to an Ivy League school after I graduated high school in Brunswick County, North Carolina. The last place my father was stationed when he earned admiral quickly became my home. Even though I’ve lived in many places before this town, I feel like I belong here. The Carolina coast is in my blood, and leaving it, even for four years, would have completely shattered my heart. So I fought hard, and won.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p174"
    }
  }, [_vm._v("The faces around me are a blur as I head for the dining room table, which was nearly sagging under the weight of all the food littering the top of it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p175"
    }
  }, [_vm._v("“I swear to God, Berk, if you hadn’t shown up in the next five minutes I was going to either shoot myself, or just straight-up leave this party and hit the bars.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p176"
    }
  }, [_vm._v("I whirl around, and the sight of the caramel-brown skin, long, spiraled hair, and chocolate eyes of my friend Mea is so healing that instant tears spring to my eyes. Wiping them away, I slam myself into her arms.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p177"
    }
  }, [_vm._v("“Mea! Ohmygod, they invited you? There "), _c('i', [_vm._v("is ")]), _vm._v("a God!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p178"
    }
  }, [_vm._v("“Of course they didn’t,” she scoffs, cheerful as ever. “I crashed. Just got back into town. I missed you, Berk!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p179"
    }
  }, [_vm._v("I just sigh and squeeze her tighter. After high school, Mea and I went to separate colleges, and a friendship with her didn’t really fit into my parents’ plan, anyway. She comes from blue-collar parents, and our families never ran in the same circles. But we were inseparable as teenagers for a reason. Mea just gets me, and I get her. We know who the other is, and she knows who everyone in my life expects me to be. She doesn’t judge, she just loves me unconditionally. The same way I do for her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p180"
    }
  }, [_vm._v("“Please tell me you’re here to stay.” My words are lost in her bare shoulder, and she laughs and pushes me back so that she can look into my eyes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p181"
    }
  }, [_vm._v("“You look like you need rescuing. Here, you take this and chug, and I’ll keep watch. Do it!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p182"
    }
  }, [_vm._v("I grab the silver flask from her hand like a lifeline and let the liquid inside burn my throat. If Mea is going to be in Lone Sands this summer, I can make it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p183"
    }
  }, [_vm._v("I will make it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p184"
    }
  }, [_vm._v("“Berkeley.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p185"
    }
  }, [_vm._v("I freeze, but only for a second. Grisham’s voice is full of disapproval. But we’ve known each other for so long, I just don’t care. And he knows it. I down about a third of the liquid in the flask before turning around to face him. The grin on Mea’s face is so wide, I’m scared that her face is going to crack from the extra pressure.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p186"
    }
  }, [_vm._v("A not-so-delicate snort escapes me, and I wipe my mouth. Good thing I didn’t apply the sensible pink lipstick my mother left on my dresser.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p187"
    }
  }, [_vm._v("“Grish? You want a sip?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p188"
    }
  }, [_vm._v("His thick, blond brow furrows, and I can see the internal battle going on behind his gorgeous, perfectly sculpted features.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p189"
    }
  }, [_vm._v("Grisham’s dirty blond hair is so thick shampoo models everywhere are screaming with jealousy, and it’s expertly styled into an array of spikes. His skin is tan and smooth, and his eyes are a green so deep a girl could see the rain forest if she stared into them long enough. There’s no denying that his tall, muscular body, the one that helped him earn Navy its first football win over Army in twenty-three years, is every woman’s fantasy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p190"
    }
  }, [_vm._v("He just isn’t "), _c('i', [_vm._v("my")]), _vm._v(" fantasy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p191"
    }
  }, [_vm._v("But he’s my friend, and I love him because he doesn’t hold me to the high standard our parents do. I know he wishes things could be different. But he’s very aware that they aren’t.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p192"
    }
  }, [_vm._v("“Give me the flask.” He sighs after a minute’s hesitation.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p193"
    }
  }, [_vm._v("I grin and hand it over. “Atta boy, Grish.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p194"
    }
  }, [_vm._v("Grinning at him as he swallows, I chuckle. “Remember the first time we got drunk? We went to Manny Reyes’s party sophomore year of high school, and I forced you to play that stupid drinking game with me? We both ended up throwing up in the bushes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p195"
    }
  }, [_vm._v("“Uh-huh,” he replies with a wry grin. “You were always getting me into trouble.” He leans closer and whispers in my ear. “Still are.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p196"
    }
  }, [_vm._v("“Can we get out of here?” Mea’s impatient. She hates being in my parents’ house, she always has. I can’t blame her. I feel the exact same way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p197"
    }
  }, [_vm._v("“Can’t.” My tone is mournful. “I haven’t seen the Admiral yet.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p198"
    }
  }, [_vm._v("So we stay, and we eat. The three of us stick close together, but each time my mother sends me a death glare fit for the Queen of the Damned, I make a round of my guests. I shake hands and smile, tilt my head and laugh. It’s all so empty I’m afraid if I huff out a breath too hard, everything will just blow away. Somehow, hidden in her tank top and short skirt, Mea has managed to sneak "), _c('i', [_vm._v("two")]), _vm._v(" tiny flasks of vodka into a party that’s only serving champagne.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p199"
    }
  }, [_vm._v("When the Admiral finally makes his entrance, I’m more than a little tipsy. Mea is flat-out drunk, and Grisham has his large, strong hands full, trying to contain the two of us. His parents are here, and he doesn’t want to disappoint them any more than I do mine. Only my back is so hunched from the load of expectations that I’m sinking, and I’m tired of trying to hold it all up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p200"
    }
  }, [_vm._v("“Berkeley.” The Admiral states my name with a punctuation point at the end. The sound of his voice sends three different emotions coursing through my body all at once: anxiety, exhaustion, and affection.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p201"
    }
  }, [_vm._v("Affection because I love my father. He’s a good dad. He’s been my dad in the only way he knew how. He was forceful at times, and gruff at others. He’s firm and immovable in his opinions, and the sky-high standards for his only child are probably just as difficult for him to uphold as they are for me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p202"
    }
  }, [_vm._v("Anxiety because every time I see my father, I know that something is going to happen that will inevitably take me farther away from where I actually want to be. Like when I came home at Christmas of my sophomore year, I was excitedly bringing brochures for a spring break trip that all of my friends had been planning since the dawn of time. Only my father preempted me, and informed me that I’d be taking a tour of navy bases overseas with him and my mother for the week of spring break instead. It was like he could feel it when I was finally going to do something for myself, and was compelled to drive me off my course and back onto his.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("Exhaustion because the person I am around my father is not the person I really am inside. I’ve been putting on an act with him for as long as I can remember, and the sand in that giant invisible timer is just about out. I can’t pretend anymore. And when the real me finally emerges, it’s going to either break his heart or flat out kill him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("I don’t want to marry the man he’s chosen for me. I don’t want a life as a navy wife like he always wanted. I want to be free and independent. And I’ve never had the courage to tell him, or my mother, how I really feel.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("As a twenty-two-year-old college graduate, I’m aware that this makes me a giant wuss.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("“Admiral,” I say just before pulling myself carefully into his embrace. He’s in dress whites, of course, and all of his decorations are badged on his uniform proudly for all to see. He should be proud of everything he’s accomplished; I understand that. But to a normal person, all that metal glinting on his shoulders is like a warning. Bright flashing lights that say "), _c('span', {
    staticClass: "smallcaps-rw",
    staticStyle: {
      "font-size": "82%"
    }
  }, [_vm._v("STAY THE FUCK AWAY FROM ME AND ALL THAT I LOVE.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("“Welcome home, sweetheart. Tomorrow we begin planning your future, yes?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("I nod numbly. “Sure.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("His eyes zero in on Grisham and he smiles warmly, and then they slide to Mea, and that smile falters slightly. “Grisham, my boy. I’ve been hearing great things about everything you’ve accomplished during your time at the academy. You’re prepared for your move to San Diego?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("My eyes travel back and forth between the two of them. “San Diego? Grish…you didn’t tell me you’ve been stationed! Congratulations!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("“Got my orders yesterday,” he whispered into my ear. “I hadn’t had time to talk to you about it yet. Apparently, we’ve been summoned to brunch with our parents in the morning.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p212"
    }
  }, [_vm._v("Sunday brunch has always been my mother’s "), _c('i', [_vm._v("thing")]), _vm._v(". Even while I was away at college, I was still expected to attend at least once a month. Grisham’s family is always there, and our mothers love to "), _c('i', [_vm._v("ooo")]), _vm._v(" and "), _c('i', [_vm._v("ahh")]), _vm._v(" about how cute we look sitting next to each other at their tables. It irritates the heck out of me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("My father leans closer, eyeing first me, and then Grisham. “No more vodka this evening, understood? You’re not in college anymore, Berkeley.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("Don’t I know it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("My father forgets to greet Mea before my mother pulls him in another direction. I watch him go, my eyes narrowed and the vodka swimming in my veins contributing to the feeling of nausea in my belly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“Now? Now can we leave?” Mea tugs on my hand.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("“Yeah,” I mutter. “Now they won’t notice I’m gone. Grish, you coming?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("He shakes his head. His mouth turns down on one side in a frown. “If I go, who’s going to cover for you?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("I reach up on my tiptoes and wrap my arms around his neck. “You’re the best.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("He leans into the kiss I plant on his cheek, and the look in his eyes is full of understanding and melancholy. “Be safe. Call me if you want me to come get you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_vm._v("I don’t have time to think about how Mea and I are going to get our drunken asses out to a bar as she pulls me outside into the salty night air. My parents’ house is located in the most affluent portion of Lone Sands. They consider this residence their beach house, because my father also occupies admiral’s quarters on the base. He stays there most of the time.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("The slightly broken look in my mother’s eyes when he leaves to go “home” is another reason I have no desire to become a military wife.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("There’s a car idling at the end of our long driveway, far enough away from the house to be inconspicuous. When Mea opens the door to the backseat, I’m greeted by her brother, Mikah, who is a couple of years younger than us, and one of his friends.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("“Hell, yes.” Mikah grins over the driver’s seat at me as I climb in. “Welcome home, Berk baby.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("Mea slams the door behind me and sends me a smug smile as we buckle up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("“Have they been waiting out here the whole time?” I’m already feeling bad for Mikah and his bleary-eyed friend.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("“Mikah has been on text alert all night,” she answers. “I sent him a message when the Admiral came in.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("I nod. “Get me the hell out of here, Mikah.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("Chuckling, he takes off, and the large muffler on the little beater he’s driving revs loudly. “I’m glad you’re home, Berk.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("I smile at him. But the jury is still out on whether or not I’m happy about being back in Lone Sands. If it’s up to my parents, I won’t be staying long.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dcd91c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s007-Chapter-003.vue
// module id = 78
// module chunks = 0